{
  "backButton": "Återgå till {prevMenuButton}",
  "moreActions": "Fler åtgärder",
  "unavailable": "Ej tillgänglig, expandera för mer information"
}
